import Panel from '~/components/Panel';

interface Props {
  medicalReason: string | null;
  primaryMedicalIssue: string | null;
  campaignTypeCode?: string | null;
  campaignTypeName?: string | null;
}

const MedicalReasonBlock: React.FC<Props> = ({
  medicalReason,
  primaryMedicalIssue,
  campaignTypeCode,
  campaignTypeName,
}) => {
  const isCompassion = campaignTypeCode === 'compassion';
  const label = isCompassion ? 'Campaign Type' : 'Medical Reason';
  const heading = isCompassion ? (campaignTypeName ?? 'Compassion') : medicalReason;
  const subheading = isCompassion ? null : primaryMedicalIssue;

  return (
    <Panel addClasses={`border-[#FFF4DB] bg-[#FFF9EC] flex-1`}>
      <div className='flex items-start justify-between'>
        <div className='flex-1'>
          <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
            {label}
          </h2>
          <div className='text-[38px]/[44px] font-bold text-[#131212]'>
            {heading}
          </div>
          {subheading && (
            <div className='text-[16px]/[24px] text-[#949599]'>
              {subheading}
            </div>
          )}
        </div>
      </div>
    </Panel>
  );
};

export default MedicalReasonBlock;
